// ADR-0005 D3: name-based cosmetic / aesthetic / nutrition-wellness denylist
// for the health category. Pure, no imports — import and re-import share this
// list. English terms match as a whole word or word-prefix against a
// lowercased, diacritic-stripped name; ASCII letters define word membership,
// so digits delimit terms. Arabic terms match as a folded substring.

export const HEALTH_IMPORT_DENYLIST_TERMS_EN = Object.freeze([
  'beauty',
  'beaute',
  'aesthetic',
  'esthetic',
  'esthetique',
  'anti-aging',
  'anti-ageing',
  'antiaging',
  'laser',
  'skin',
  'skincare',
  'derma',
  'cosmetic',
  'botox',
  'filler',
  'slim',
  'nutrition',
  'nutri',
  'diet',
  'hair',
  'spa',
  'wellness',
  'glow',
  'facial',
  'lifting',
  'massage',
  'weight loss',
]);

export const HEALTH_IMPORT_DENYLIST_TERMS_AR = Object.freeze([
  'تجميل',
  'جمال',
  'بشرة',
  'ليزر',
  'بوتوكس',
  'تنحيف',
  'تغذية',
  'حمية',
  'رجيم',
  'ريجيم',
  'شعر',
  'سبا',
  'نضارة',
  'مساج',
]);

const PREFIX_EN = Object.freeze(new Set([
  'derma',
  'cosmetic',
  'filler',
  'slim',
  'nutrition',
  'nutri',
  'diet',
]));

function foldEnglish(value) {
  return String(value)
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase();
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function englishTermPattern(term, prefix) {
  const escaped = escapeRegExp(term);
  if (prefix) {
    return new RegExp(`(^|[^a-z])${escaped}(?=[a-z]*([^a-z]|$))`);
  }
  return new RegExp(`(^|[^a-z])${escaped}([^a-z]|$)`);
}

function hyphenVariants(value) {
  if (!value.includes('-')) return [value];
  return [value, value.replace(/-/g, '')];
}

function matchesEnglishTerm(folded, term, prefix) {
  const pattern = englishTermPattern(term, prefix);
  for (const haystack of hyphenVariants(folded)) {
    for (const candidate of hyphenVariants(term)) {
      const re = candidate === term ? pattern : englishTermPattern(candidate, prefix);
      if (re.test(haystack)) return true;
    }
  }
  return false;
}

export function isCosmeticHealthName(name) {
  if (name == null) return false;
  const raw = String(name);
  if (!raw.trim()) return false;
  const folded = foldEnglish(raw);
  for (const term of HEALTH_IMPORT_DENYLIST_TERMS_EN) {
    if (matchesEnglishTerm(folded, term, PREFIX_EN.has(term))) return true;
  }
  for (const term of HEALTH_IMPORT_DENYLIST_TERMS_AR) {
    if (folded.includes(term)) return true;
  }
  return false;
}
